import { Box, Button, Card, Checkbox, FormControlLabel, Grid, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Tabs, Tab } from "@mui/material";
import axios from "../api/axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../contexts/AuthProvider";

const  LoginPage= () => {

        const textFieldStyle = {
                '& .MuiInputLabel-root': { 
                        color: '#666', 
                        fontWeight: 600,
                        transform: 'translate(14px, -9px) scale(0.75)',
                        backgroundColor: 'white',
                        padding: '0 4px'
                },
                '& .MuiInputLabel-root.Mui-focused': { color: '#1976d2', fontWeight: 700 },
                '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#ccc', borderWidth: 2 },
                        '&:hover fieldset': { borderColor: '#1976d2' },
                        '&.Mui-focused fieldset': { borderColor: '#1976d2', borderWidth: 2 },
                        '& input': { color: '#333', fontWeight: 500 }
                }
        };

        const {setAuth, persist, setPersist} =useContext(AuthContext);
        const [email, setEmail] = useState("");
        const [password, setPassword] = useState("");
        const [loginError, setLoginError] = useState(false);
        const [errorMessage, setErrorMessage] = useState("");
        const [loginType, setLoginType] = useState(0); // 0 = Cliente, 1 = Super Admin

        const navigate = useNavigate();
        
        


        
        const togglePersist=()=>{
                setPersist(prev=> !prev);
        }

        useEffect(()=>{
                localStorage.setItem("persist",persist);
        },[persist])
        
        const login = () =>{
                setLoginError(false); // Reset error state
                
                // Usa sempre lo stesso endpoint /auth
                const endpoint = "/auth";
                
                // Prepara i dati del login
                const loginData = loginType === 1 
                        ? { email: email, password: password, loginType: "superadmin" }
                        : { email: email, password: password, loginType: "customer" };
                
                axios.post(endpoint,
                        JSON.stringify(loginData),
                        {
                                headers:{'Content-Type': 'application/json'},
                                withCredentials: true
                        }
                ).then((response) => {

                        if (loginType === 1) {
                                // Login Super Admin
                                if (response.data.accessToken) {
                                        const accessToken = response.data.accessToken;
                                        const userType = response.data.userType || 'superadmin';
                                        
                                        // Salva il token nel localStorage per le API SaaS
                                        localStorage.setItem('adminToken', accessToken);
                                        
                                        const authData = {
                                                email: email,
                                                password,
                                                accessToken,
                                                userType: 'superadmin'
                                        };
                                        
                                        setAuth(authData);
                                        
                                        setEmail("");
                                        setPassword("");
                                        
                                        // Reindirizza alla dashboard SaaS Admin
                                        const adminPath = process.env.REACT_APP_ADMIN_PATH || '/admin';
                                        navigate(adminPath + '/dashboard', { replace: true });
                                } else {
                                        setLoginError(true);
                                        setErrorMessage(response.data.message || "Credenziali non valide");
                                }
                        } else {
                                // Login Cliente - gestisce anche la risposta multi-tenant
                                        if (response.data.accessToken) {
                                        const accessToken = response.data.accessToken;
                                        const userType = response.data.userType || 'customer';
                                        const customerCode = response.data.customerCode;
                                                const customerDatabase = response.data.customerDatabase;
                                        const customer_id = response.data.customer_id;
                                        const fullName = response.data.fullName;
                                        const role = response.data.role;
                                        
                                        const authData = {
                                                email,
                                                password,
                                                accessToken, 
                                                userType,
                                                customerCode,
                                                        customerDatabase,
                                                customer_id,
                                                fullName,
                                                role
                                        };
                                        
                                        setAuth(authData);
                                        
                                        setEmail("");
                                        setPassword("");
                                        
                                        const basePath = process.env.REACT_APP_BASE_PATH || '/dashboard';
                                        navigate(basePath, { replace: true });
                                } else{
                                        setLoginError(true);
                                        setErrorMessage(response.data.message || "Credenziali non valide");
                                }
                        }
                }).catch(function(error){
                        setLoginError(true);
                        
                        if(error.response?.status === 401) {
                                setErrorMessage("Email o password non corretti");
                        } else if(error.response?.status === 500) {
                                setErrorMessage("Errore del server. Riprova più tardi");
                        } else if(error.code === 'ERR_NETWORK') {
                                setErrorMessage("Impossibile connettersi al server");
                        } else {
                                setErrorMessage("Errore durante il login. Riprova");
                        }
                })
        };
        

        return (
                <Box 
                        component="main" 
                        sx={{ 
                                minHeight: '100vh',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#2d3748',
                                py: 4,
                                px: 2
                        }}
                >
                        <Grid container sx={{ maxWidth: 1200, minHeight: { xs: 'auto', md: '600px' }, boxShadow: 3, borderRadius: '12px' }}>
                                {/* Parte sinistra - Illustrazione */}
                                <Grid item xs={12} md={6} sx={{ 
                                        background: 'linear-gradient(135deg, #1a365d 0%, #2c5282 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        p: 4,
                                        borderRadius: { xs: '12px 12px 0 0', md: '12px 0 0 12px' },
                                        position: 'relative',
                                        overflow: 'hidden',
                                        minHeight: { xs: '250px', md: 'auto' }
                                }}>
                                        <Box sx={{ 
                                                textAlign: 'center', 
                                                color: 'white',
                                                zIndex: 1,
                                                position: 'relative'
                                        }}>
                                                <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: '1.8rem', md: '3rem' } }}>
                                                        Gestionale Anziani
                                                </Typography>
                                                <Typography variant="h6" sx={{ opacity: 0.9, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                                                        Piattaforma di gestione integrata
                                                </Typography>
                                        </Box>
                                        {/* Decorazioni */}
                                        <Box sx={{
                                                position: 'absolute',
                                                top: -50,
                                                right: -50,
                                                width: 200,
                                                height: 200,
                                                borderRadius: '50%',
                                                background: 'rgba(255,255,255,0.1)',
                                        }} />
                                        <Box sx={{
                                                position: 'absolute',
                                                bottom: -80,
                                                left: -80,
                                                width: 250,
                                                height: 250,
                                                borderRadius: '50%',
                                                background: 'rgba(255,255,255,0.05)',
                                        }} />
                                </Grid>

                                {/* Parte destra - Form */}
                                <Grid item xs={12} md={6} sx={{ 
                                        bgcolor: 'white',
                                        p: { xs: 4, md: 6 },
                                        borderRadius: { xs: '0 0 12px 12px', md: '0 12px 12px 0' },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center'
                                }}>
                                        <Box sx={{ width: '100%' }}>
                                                <Grid container direction={'column'} spacing={3}>

                        <Grid item xs={12} sx={{ textAlign: 'center', mb: 2 }}>
                                <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a365d', mb: 1 }}>
                                        Benvenuto nella
                                </Typography>
                                <Typography variant="h5" sx={{ fontWeight: 600, color: '#2c5282' }}>
                                        Piattaforma Gestionale
                                </Typography>
                        </Grid>

                        {loginType === 1 && (
                                <Grid item xs={12}>
                                        <Button 
                                                variant="text" 
                                                onClick={() => setLoginType(0)}
                                                sx={{ 
                                                        textTransform: 'none',
                                                        color: '#2c5282',
                                                        mb: 2
                                                }}
                                        >
                                                ← Torna al login cliente
                                        </Button>
                                </Grid>
                        )}                                        <Grid item xs={12}>
                                                <TextField 
                                                        id="email" 
                                                        variant="outlined" 
                                                        fullWidth
                                                        onChange={(e)=> setEmail(e.target.value)}
                                                        value={email}
                                                        placeholder={loginType === 0 ? "Scrivi Indirizzo Email..." : "Username Admin"}
                                                        sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                        borderRadius: '50px',
                                                                        bgcolor: '#f7fafc',
                                                                        '& fieldset': { borderColor: '#e2e8f0', borderWidth: 1 },
                                                                        '&:hover fieldset': { borderColor: '#2c5282', borderWidth: 1 },
                                                                        '&.Mui-focused fieldset': { borderColor: '#0891b2', borderWidth: 2 },
                                                                        '& input': { 
                                                                                py: 1.5, 
                                                                                px: 2.5,
                                                                                color: '#1a202c',
                                                                                fontSize: '1rem',
                                                                                '&::placeholder': {
                                                                                        color: '#a0aec0',
                                                                                        opacity: 1
                                                                                }
                                                                        }
                                                                }
                                                        }}
                                                />
                                        </Grid>
                                        <Grid item xs={12}>
                                                <TextField 
                                                        id="password" 
                                                        type="password" 
                                                        variant="outlined" 
                                                        fullWidth
                                                        onChange={(e)=> setPassword(e.target.value)}
                                                        value={password}
                                                        placeholder="Password"
                                                        sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                        borderRadius: '50px',
                                                                        bgcolor: '#f7fafc',
                                                                        '& fieldset': { borderColor: '#e2e8f0', borderWidth: 1 },
                                                                        '&:hover fieldset': { borderColor: '#2c5282', borderWidth: 1 },
                                                                        '&.Mui-focused fieldset': { borderColor: '#0891b2', borderWidth: 2 },
                                                                        '& input': { 
                                                                                py: 1.5, 
                                                                                px: 2.5,
                                                                                color: '#1a202c',
                                                                                fontSize: '1rem',
                                                                                '&::placeholder': {
                                                                                        color: '#a0aec0',
                                                                                        opacity: 1
                                                                                }
                                                                        }
                                                                }
                                                        }}
                                                />
                                                {loginType === 1 && (
                                                        <Typography variant="caption" sx={{ mt: 1, display: 'block', color: '#666' }}>
                                                                Credenziali predefinite: superadmin / admin123
                                                        </Typography>
                                                )}
                                        </Grid>
                                        <Grid item xs={12}>
                                                <FormControlLabel 
                                                        control={<Checkbox checked={persist} onChange={togglePersist} sx={{ color: '#2c5282' }} />} 
                                                        label="Ricordami"
                                                        sx={{ 
                                                                color: '#4a5568',
                                                                '& .MuiTypography-root': { fontSize: '0.9rem' }
                                                        }}
                                                />
                                        </Grid>
                                        <Grid item xs={12}>
                                                <Button 
                                                        variant="contained" 
                                                        fullWidth 
                                                        onClick={login}
                                                        sx={{
                                                                borderRadius: '50px',
                                                                py: 1.5,
                                                                textTransform: 'uppercase',
                                                                fontWeight: 700,
                                                                fontSize: '1rem',
                                                                bgcolor: '#0891b2',
                                                                '&:hover': { bgcolor: '#0e7490' }
                                                        }}
                                                >
                                                        LOGIN
                                                </Button>
                                        </Grid>
                                        
                                                        {loginType === 0 && (
                                                                <>
                                                                        <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                                                                <Typography variant="body2" sx={{ color: '#666' }}>
                                                                                        Non hai ancora un account?{' '}
                                                                                        <Button 
                                                                                                variant="text" 
                                                                                                onClick={() => navigate('/register')}
                                                                                                sx={{ textTransform: 'none', fontWeight: 600, color: '#0891b2', p: 0, minWidth: 'auto' }}
                                                                                        >
                                                                                                Registrati qui
                                                                                        </Button>
                                                                                </Typography>
                                                                        </Grid>
                                                                        
                                                                        <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                                                                <Button 
                                                                                        variant="text" 
                                                                                        size="small"
                                                                                        onClick={() => setLoginType(1)}
                                                                                        sx={{ 
                                                                                                textTransform: 'none', 
                                                                                                color: '#718096',
                                                                                                fontSize: '0.85rem'
                                                                                        }}
                                                                                >
                                                                                        Accesso Super Admin →
                                                                                </Button>
                                                                        </Grid>
                                                                </>
                                                        )}

                                                </Grid>
                                        </Box>
                                </Grid>
                        </Grid>

                        {/* Dialog per errori di login */}
                        <Dialog
                                open={loginError}
                                onClose={() => setLoginError(false)}
                                aria-labelledby="login-error-dialog"
                                maxWidth="sm"
                                fullWidth
                        >
                                <DialogTitle id="login-error-dialog">
                                        Errore di Accesso
                                </DialogTitle>
                                <DialogContent>
                                        <Alert severity="error" sx={{ mt: 1 }}>
                                                {errorMessage}
                                        </Alert>
                                </DialogContent>
                                <DialogActions>
                                        <Button 
                                                onClick={() => setLoginError(false)} 
                                                variant="contained"
                                                color="primary"
                                        >
                                                OK
                                        </Button>
                                </DialogActions>
                        </Dialog>

                </Box>
);
}
 
export default LoginPage;